import { createSlice } from '@reduxjs/toolkit';
import { fetchInteractionById, updateFlowStepApi } from '../../api/interactionApi';

const interactionSlice = createSlice({
  name: 'interaction',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearInteraction: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInteractionById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInteractionById.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchInteractionById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateFlowStepApi.fulfilled, (state, action) => {
        if (state.data?.id === action.payload.id) {
          state.data.flow_step = action.payload.flow_step;
        }
      });
  },
});

export const { clearInteraction } = interactionSlice.actions;
export default interactionSlice.reducer;



